export const constants = {
  SET_AREAS: "SET_AREAS",
  SET_CHECKED_AREAS: "SET_CHECKED_AREAS",
  RESET_CHECKED_AREAS: "RESET_CHECKED_AREAS",
  SET_TREES: "SET_TREES",
  RESET_TREES: "RESET_TREES",
  SET_CHECKED_TREES: "SET_CHECKED_TREES",
  RESET_CHECKED_TREES: "RESET_CHECKED_TREES",
  SET_INSTALLATIONS: "SET_INSTALLATIONS",
  RESET_INSTALLATIONS: "RESET_INSTALLATIONS",
  SET_CHECKED_INSTALLATIONS: "SET_CHECKED_INSTALLATIONS",
  RESET_CHECKED_INSTALLATIONS: "RESET_CHECKED_INSTALLATIONS",
  SET_VARIABLES: "SET_VARIABLES",
  RESET_VARIABLES: "RESET_VARIABLES",
  SET_CHECKED_VARIABLES: "SET_CHECKED_VARIABLES",
  RESET_CHECKED_VARIABLES: "RESET_CHECKED_VARIABLES",
  SET_RAIN_AREA: "SET_RAIN_AREA",
  SET_HEALTH_TREE: "SET_HEALTH_TREE",
  SET_IRRIGATION_TREE: "SET_IRRIGATION_TREE",
};
